import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function WomanOnBridge({...props}) {
    const {
      className,
      imageUrl,
      children,
      style
    } = props;
    const data = useStaticQuery(
      graphql`
        query {
          desktop: file(relativePath: { eq: "woman-on-bridge.jpg" }) {
            childImageSharp {
              fluid(quality: 70, maxWidth: 960) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `
    );

    // Set ImageData.
    const imageData = data.desktop.childImageSharp.fluid;

    return (
      <BackgroundImage 
      Tag="div"
      role="img"
      aria-label="A woman on a footbridge looking out into the distance, as seen from back"
      className={className}
      fluid={imageData}
      style={style}
      >
        {children}
      </BackgroundImage>
    )
  }

const styles = {
  width: "100%",
  backgroundPosition: "bottom center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
}

export default withStyles(styles)(WomanOnBridge)